import React from 'react'
import styled from 'styled-components';
import {colours} from '../Styles';
import MaxContent from './MaxContent'
import FlexCenterCenter from './FlexCenterCenter';
import WhyChooseItem from './WhyChooseItem';

function WhyChoosePD() {
    const {light} = colours;
    const WhyChoosePD = styled.div`
        width: 100%;
        display: flex;
        min-height: 250px;
        margin-top: 20px;
        margin-bottom: 20px;
        background: ${light};
        flex-wrap: wrap;
    `;
    return (
        <FlexCenterCenter>
            <MaxContent>
                <WhyChoosePD>
                    <WhyChooseItem text="Mobile service options available"/>
                    <WhyChooseItem text="Catered packages for your vehicle"/>
                    <WhyChooseItem text="Premium results-proven products"/>
                    <WhyChooseItem text="Serving the Greater Toronto Area"/>
                    <WhyChooseItem text="Passionate car care technicians"/>
                    <WhyChooseItem text="White glove customer service"/>
                </WhyChoosePD>
            </MaxContent>
        </FlexCenterCenter>
    )
}

export default WhyChoosePD;